export interface EditorialCard {
  id: string;
  category: 'Places' | 'Objects' | 'Experiences' | 'Markets' | 'People' | 'Collections';
  title: string;
  subtitle: string;
  excerpt: string;
  image: string;
  alt: string;
  location?: string;
  readTime: number;
  publishedDate: string;
  isFirstSeen: boolean;
  exclusivityLevel: 'Singular' | 'Rare' | 'Exclusive';
  provenance?: string;
  isSaved: boolean;
  size: 'large' | 'medium' | 'small';
}

export const editorialCards: EditorialCard[] = [
{
  id: 'card-001',
  category: 'Places',
  title: 'The Derawar Fort at Night',
  subtitle: 'A 40-towered desert citadel with no visitors, no lighting, and no road on the map',
  excerpt: 'In the Cholistan Desert of southern Punjab, a perfectly intact Abbasid-era fortress rises from the sand — 40 bastions, each 30 metres high, entirely unreachable without a private 4x4 and a local contact.',
  image: "https://images.unsplash.com/photo-1713682995521-22ec819b50ac",
  alt: 'Ancient desert fortress with cylindrical towers rising dramatically from golden sand dunes at sunset',
  location: 'Cholistan Desert, Pakistan',
  readTime: 11,
  publishedDate: '12 Aug 2026',
  isFirstSeen: true,
  exclusivityLevel: 'Singular',
  provenance: 'Abbasid Dynasty, 9th century',
  isSaved: false,
  size: 'large'
},
{
  id: 'card-002',
  category: 'Objects',
  title: 'A. Lange & Söhne Grand Complication',
  subtitle: 'The only mechanical timepiece to combine a perpetual calendar, split-seconds chronograph and tourbillon in a single case under 15mm',
  excerpt: 'Made in Glashütte by a team of seven watchmakers over four years, this reference has appeared at auction precisely twice. The second time, it did not sell.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_17e2089ab-1772219942032.png",
  alt: 'Exquisite platinum pocket watch with intricate silver dial and multiple complications displayed on dark velvet',
  readTime: 9,
  publishedDate: '11 Aug 2026',
  isFirstSeen: false,
  exclusivityLevel: 'Singular',
  provenance: 'A. Lange & Söhne, Glashütte, 2019',
  isSaved: true,
  size: 'medium'
},
{
  id: 'card-003',
  category: 'Experiences',
  title: 'The Last Private Dinner at Noma',
  subtitle: 'René Redzepi hosts twelve guests, once a year, at a table that does not appear on any menu',
  excerpt: 'This is not a reservation. It is an introduction. Twelve people. A single autumn evening. A menu constructed around foraging done that morning within 40 kilometres of Copenhagen.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_164f17ebc-1776287874974.png",
  alt: 'Intimate restaurant dining room with candlelit table set for twelve with artful plating and Nordic decor',
  location: 'Copenhagen, Denmark',
  readTime: 7,
  publishedDate: '10 Aug 2026',
  isFirstSeen: true,
  exclusivityLevel: 'Singular',
  isSaved: false,
  size: 'medium'
},
{
  id: 'card-004',
  category: 'Markets',
  title: 'The Quiet Correction in Hong Kong Jades',
  subtitle: 'Imperial-grade jadeite has declined 23% since 2023 — and the right buyers know exactly why',
  excerpt: 'Three major Hong Kong collecting families have been quietly liquidating. The reasons are geopolitical, personal, and generational — and the window for a counter-position is narrow.',
  image: "https://images.unsplash.com/photo-1606815216310-aead1e97b9b2",
  alt: 'Collection of luminous green imperial jade bangles and carved pendants displayed on white silk',
  readTime: 14,
  publishedDate: '9 Aug 2026',
  isFirstSeen: false,
  exclusivityLevel: 'Rare',
  isSaved: false,
  size: 'small'
},
{
  id: 'card-005',
  category: 'People',
  title: 'Yusuf Al-Mansouri',
  subtitle: 'The Qatari collector who has quietly assembled the world\'s most significant private collection of Ottoman manuscripts',
  excerpt: 'He has never given an interview. He does not attend auctions. His acquisitions are made through intermediaries who have worked with him for twenty years. We are the first publication to profile him.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a8da636c-1765338815557.png",
  alt: 'Distinguished middle-aged man in elegant dark suit seated in library surrounded by ancient leather-bound manuscripts',
  readTime: 18,
  publishedDate: '8 Aug 2026',
  isFirstSeen: true,
  exclusivityLevel: 'Singular',
  isSaved: true,
  size: 'large'
},
{
  id: 'card-006',
  category: 'Collections',
  title: 'The Thyssen-Bornemisza Private Reserve',
  subtitle: 'The 57 works that never entered the museum — and what happens to them when the estate settles',
  excerpt: 'When the Thyssen-Bornemisza collection was sold to Spain, 57 works were retained by the family. They have been in private storage since 1993. The estate is in discussions. The timeline is 18 months.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_11bdf0f59-1772854306027.png",
  alt: 'Grand museum gallery with high ceilings displaying Old Master paintings in gilded frames under warm spotlights',
  readTime: 16,
  publishedDate: '7 Aug 2026',
  isFirstSeen: false,
  exclusivityLevel: 'Rare',
  isSaved: false,
  size: 'medium'
},
{
  id: 'card-007',
  category: 'Places',
  title: 'Socotra\'s Dragon Blood Forest',
  subtitle: 'An island that evolved in complete isolation for 35 million years — accessible by private charter from Muscat',
  excerpt: 'The trees are shaped like inverted umbrellas. The sap is red. The island sits in the Arabian Sea and looks like nothing on Earth — because for 35 million years, it was not connected to it.',
  image: "https://images.unsplash.com/photo-1708464437353-f3bc347ff5b3",
  alt: 'Surreal landscape with umbrella-shaped Dragon Blood trees against dramatic cloudy sky on isolated island',
  location: 'Socotra Island, Yemen',
  readTime: 10,
  publishedDate: '6 Aug 2026',
  isFirstSeen: true,
  exclusivityLevel: 'Singular',
  provenance: 'UNESCO World Heritage Site',
  isSaved: false,
  size: 'small'
},
{
  id: 'card-008',
  category: 'Objects',
  title: 'The Bhutan Postal Museum Collection',
  subtitle: 'The only country to have issued silk, steel and embossed stamps — 400 of which were never released to the public',
  excerpt: 'In 1973, Bhutan\'s postal authority commissioned a series of 400 experimental stamps in unconventional materials. They were never issued. They have been in a Thimphu archive ever since.',
  image: "https://images.unsplash.com/photo-1693638857636-e16b5f2aa8bb",
  alt: 'Rare philatelic collection of unusual stamps in ornate frames displayed in museum case with magnifying glass',
  readTime: 12,
  publishedDate: '5 Aug 2026',
  isFirstSeen: false,
  exclusivityLevel: 'Rare',
  provenance: 'Royal Government of Bhutan, 1973',
  isSaved: false,
  size: 'medium'
},
{
  id: 'card-009',
  category: 'Experiences',
  title: 'A Private Audience at Gyuto Monastery',
  subtitle: 'The Tantric monks of Dharamsala offer one private audience per year — the application process begins eighteen months prior',
  excerpt: 'The Gyuto Monks are the custodians of multiphonic chanting — a practice so demanding that it takes twelve years to master. A private audience is not a performance. It is a transmission.',
  image: "https://images.unsplash.com/photo-1727962239404-fa7dc4f0124c",
  alt: 'Tibetan monastery courtyard with monks in saffron robes performing ceremonial rituals with butter lamps glowing',
  location: 'Dharamsala, India',
  readTime: 9,
  publishedDate: '4 Aug 2026',
  isFirstSeen: true,
  exclusivityLevel: 'Singular',
  isSaved: false,
  size: 'small'
},
{
  id: 'card-010',
  category: 'Markets',
  title: 'Why Single-Malt Casks Are Outperforming Every Asset Class in 2026',
  subtitle: 'The three distilleries whose cask programs have returned 31–47% over 36 months — and the one about to close its allocation',
  excerpt: 'Whisky cask investment has matured from a curiosity into a legitimate alternative asset. Three Scottish distilleries are responsible for most of the outperformance — and one closes its cask program to new members in September.',
  image: "https://images.unsplash.com/photo-1603971729146-58cc08a42e76",
  alt: 'Row of aged oak whisky barrels in dark stone warehouse cellar with golden light filtering through wooden slats',
  readTime: 15,
  publishedDate: '3 Aug 2026',
  isFirstSeen: false,
  exclusivityLevel: 'Exclusive',
  isSaved: true,
  size: 'large'
},
{
  id: 'card-011',
  category: 'People',
  title: 'Isabelle Moreau-Delacroix',
  subtitle: 'The Paris-based gemologist who has authenticated more disputed Mughal emeralds than any institution in the world',
  excerpt: 'She works from a studio in the 6th arrondissement. She does not have a website. She is consulted by Christie\'s, Sotheby\'s, and three sovereign wealth funds — and she charges accordingly.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1809a1879-1772088342982.png",
  alt: 'Elegant French woman in her fifties examining gemstone through loupe in sunlit Parisian atelier with jewellery tools',
  readTime: 13,
  publishedDate: '2 Aug 2026',
  isFirstSeen: false,
  exclusivityLevel: 'Rare',
  isSaved: false,
  size: 'medium'
},
{
  id: 'card-012',
  category: 'Collections',
  title: 'The Corsini Private Library, Florence',
  subtitle: '30,000 volumes — including 200 incunabula — in a palazzo that has never been photographed',
  excerpt: 'The Corsini family has maintained a private library in their Florence palazzo since 1480. It has never been catalogued by an outside institution. It has never been photographed. The family recently agreed to one private viewing per year for serious collectors.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1154f3916-1772291203495.png",
  alt: 'Ancient library with floor-to-ceiling dark wood shelves filled with leather-bound books in Renaissance palazzo room',
  location: 'Florence, Italy',
  readTime: 17,
  publishedDate: '1 Aug 2026',
  isFirstSeen: true,
  exclusivityLevel: 'Singular',
  isSaved: false,
  size: 'small'
}];


export const collectionsData = [
{ id: 'col-001', name: 'Architectural Obscurities', count: 23, emoji: '🏛' },
{ id: 'col-002', name: 'Rare Horology', count: 11, emoji: '⌚' },
{ id: 'col-003', name: 'Private Dining Experiences', count: 8, emoji: '🍽' },
{ id: 'col-004', name: 'Collector Intelligence', count: 17, emoji: '📊' },
{ id: 'col-005', name: 'Extraordinary People', count: 6, emoji: '👤' }];